import React, { useState, useRef, useEffect } from 'react';
import { Send, Sparkles, Ticket } from 'lucide-react';

const SUGGESTIONS = [
  '🎓 What career training tracks does Sagveek offer in Pune?',
  '📅 How do I reserve a seat for a free live demo class?',
  '💼 What enterprise software & custom AI solutions do you build?',
  '🚀 What dedicated placement assistance does Sagveek provide?',
  '🎫 Submit a project or course inquiry ticket',
];

export function ChatInput({
  onSendMessage,
  isLoading,
  showSuggestions = false,
  onOpenTicketForm,
}) {
  const [text, setText] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    // Only auto-focus on desktop screens to avoid unintended keyboard pops on mobile devices
    if (!isLoading && textareaRef.current && window.innerWidth > 640) {
      textareaRef.current.focus();
    }
  }, [isLoading]);

  const handleInput = (e) => {
    setText(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = `${Math.min(e.target.scrollHeight, 100)}px`;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (!text.trim() || isLoading) return;
    onSendMessage(text);
    setText('');
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  const handleChipClick = (suggestion) => {
    if (isLoading) return;
    if (suggestion.includes('ticket') && onOpenTicketForm) {
      onOpenTicketForm();
      return;
    }
    onSendMessage(suggestion);
  };

  return (
    <div className="chat-footer">
      {showSuggestions && (
        <div className="quick-chips-container">
          <span className="quick-chips-title">Suggested actions</span>
          <div className="chips-list">
            {SUGGESTIONS.map((s, idx) => (
              <button
                key={idx}
                type="button"
                className="chip-btn"
                onClick={() => handleChipClick(s)}
                disabled={isLoading}
              >
                {s.includes('ticket') ? (
                  <Ticket size={11} color="#6366f1" />
                ) : (
                  <Sparkles size={11} color="#6366f1" />
                )}
                <span>{s}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="chat-input-wrapper">
        <textarea
          ref={textareaRef}
          rows={1}
          value={text}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          placeholder="Ask a question about Sagveek..."
          className="chat-textarea"
          disabled={isLoading}
        />
        <button
          type="submit"
          disabled={!text.trim() || isLoading}
          className="send-btn"
          aria-label="Send message"
        >
          <Send size={15} />
        </button>
      </form>

      <div className="chat-footer-brand">
        <span>Powered by Sagveek Assistant</span>
        <span>•</span>
        <span>Gemini AI</span>
      </div>
    </div>
  );
}
